// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__2TxKA","title":"style_title__34vvg","time":"style_time__39U_i","content":"style_content__2tzSb","tabs":"style_tabs__36rDh"};